@if (design) {
  <ng-container [ngTemplateOutlet]="DESIGN_4"></ng-container>
}
<ng-template #DESIGN_4>
  <div class="page-content donation-details" fxLayout="column">
    <div fxLayout="column" fxLayout.gt-sm="row" class="progress-wrapper">
      <app-create-progress fxFlex [step]="flowStep" [flowConfiguration]="flowConfiguration" />
    </div>
    <div class="donation-info step-content" fxLayoutAlign="center center" fxLayoutAlign.lt-md="center start" fxFlex>
      <div fxLayout="column" fxLayoutAlign="center center">
        <h1>What Floor Are Your Donation Items On?</h1>
        <h3>
          Please enter the highest floor level where any of your items are located. Bringing them to the ground floor can simplify your
          pickup and reduce fees (additional charges apply per flight of stairs).
        </h3>
        @if (flowService.lead) {
          <div class="donation-spec" fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="20px" fxLayoutGap.gt-sm="30px">
            <div fxLayout="column" fxLayoutGap="0" fxLayoutGap.lt-md="20px">
              <div fxLayout="column" fxLayoutGap="10px" style="margin-bottom: 10px">
                <div fxLayout="column" fxLayoutGap="20px" class="staircases-info">
                  <span class="section-title">Which floor are you on?</span>
                  <div fxLayout="row wrap" fxLayoutGap="5px">
                    <button
                      class="primary-btn"
                      (click)="customFloor = false; staircases = 0; willBringItemsToGroundFloor = undefined"
                      [ngClass]="{ 'filled-btn': staircases === 0 && !customFloor }"
                    >
                      Ground
                    </button>
                    <button
                      class="primary-btn"
                      (click)="customFloor = false; staircases = 1; willBringItemsToGroundFloor = undefined"
                      [ngClass]="{ 'filled-btn': staircases === 1 && !customFloor }"
                    >
                      Second
                    </button>
                    <button
                      class="primary-btn"
                      (click)="customFloor = false; staircases = 2; willBringItemsToGroundFloor = undefined"
                      [ngClass]="{ 'filled-btn': staircases === 2 && !customFloor }"
                    >
                      Third
                    </button>
                    <button
                      class="primary-btn"
                      (click)="customFloor = false; staircases = 3; willBringItemsToGroundFloor = undefined"
                      [ngClass]="{ 'filled-btn': staircases === 3 && !customFloor }"
                    >
                      Fourth
                    </button>
                    <button
                      class="primary-btn"
                      (click)="customFloor = true; staircases = 5; willBringItemsToGroundFloor = undefined"
                      [ngClass]="{ 'filled-btn': customFloor }"
                    >
                      Enter floor
                    </button>
                  </div>
                  @if (customFloor) {
                    <div class="custom-floor" fxLayout="column" fxLayoutGap="8px">
                      <label>Enter Floor Manually</label>
                      <input type="number" [ngClass]="{ invalid: showErrors && staircases < 0 }" [(ngModel)]="staircases" [min]="5" />
                      @if (staircases < 5) {
                        <mat-error>Please enter floor higher than 4 or choose one of predefined options</mat-error>
                      }
                    </div>
                  }
                  @if (staircases > 0) {
                    <div class="staircases-clear" [ngClass]="{ invalid: showErrors && willBringItemsToGroundFloor === undefined }">
                      <span>Are you willing to bring your items to the ground floor?</span>
                      <mat-radio-group [(ngModel)]="willBringItemsToGroundFloor" fxLayout="column" (change)="showErrors = false">
                        <mat-radio-button class="staircases-radio-button" [value]="true">
                          <b>Yes</b>
                          , I will bring them to the ground floor
                        </mat-radio-button>
                        <mat-radio-button class="staircases-radio-button" [value]="false">
                          <b>No</b>
                          , I won’t bring them to the ground floor
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <app-page-footer (onSubmit)="saveLead()" [hasBack]="hasBack" (onBack)="back()" />
  </div>
</ng-template>
